import classNames from 'classnames';
import React from 'react';
import type { GroupBase } from 'react-select';
import type { OptionTypeBase, SelectProps } from '../Select';
import Select from '../Select';
import styles from './SelectControl.module.scss';

export type SelectControlProps<
  Option extends OptionTypeBase,
  IsMulti extends boolean = boolean,
  IsClearable extends boolean = boolean,
> = Omit<
  SelectProps<Option, IsMulti, true, GroupBase<Option>, IsClearable>,
  'creatable'
> & {
  isMulti?: IsMulti;
  label?: React.ReactNode;
  error?: string;
  disabled?: boolean;
};

const SelectControl = <
  Option extends OptionTypeBase,
  IsMulti extends boolean = false,
  IsClearable extends boolean = false,
>({
  label,
  error,
  disabled,
  ...inputProps
}: SelectControlProps<Option, IsMulti, IsClearable>) => (
  <label>
    {!!label && <div className={styles.label}>{label}</div>}
    <div className={styles.inputContainer}>
      <Select<Option, IsMulti, true, GroupBase<Option>, IsClearable>
        className={classNames(styles.select, { [styles.error]: error })}
        blurInputOnSelect
        simpleValue
        isDisabled={disabled}
        {...inputProps}
      />
    </div>
  </label>
);

export default SelectControl;
